export default "__VITE_ASSET__qO6N62M9__"